import React, { MouseEvent, useEffect, useRef } from 'react';
import { useField } from '@unform/core';

import { Root, ContainerTitle, ContainerOptions, Option } from './styles';

interface CheckboxOptionProps {
  id: string;
  label: string;
  checked?: boolean;
  buttonClick?: () => void;
  titleButtonClick?: string;
}

interface CheckboxProps {
  title?: string;
  name: string;
  options: CheckboxOptionProps[];
  link?: string;
  handleChecked?: (e: MouseEvent) => void;
}

const Checkbox: React.FC<CheckboxProps> = ({ title, name, options, link, handleChecked } : CheckboxProps) => {
  const inputRef = useRef<HTMLInputElement[]>([]);
  const { fieldName, registerField, defaultValue = [] } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      getValue: (refs: HTMLInputElement[]) => {
        return refs.filter(ref => ref.checked).map(ref => ref.value);
      },
      clearValue: (refs: HTMLInputElement[]) => {
        refs.forEach(ref => {
          ref.checked = false;
        });
      },
      setValue: (refs: HTMLInputElement[], values: string[]) => {
        refs.forEach(ref => {
          if (values.includes(ref.id)) {
            ref.checked = true;
          }
        });
      },
    });
  }, [defaultValue, fieldName, registerField]);

  return (
    <Root>
      {
        title && (
          <ContainerTitle>
          {
            link ? (<a href={link} target="_blank" rel="noopener noreferrer" >{title}</a>) : <span>{title}</span>
          }
          </ContainerTitle>
        )
      }
      <ContainerOptions>
        {options.map((option, index) => (
          <Option htmlFor={option.id} key={option.id}>
            <input
              type="checkbox"
              name={fieldName}
              ref={ref => {
                inputRef.current[index] = ref as HTMLInputElement;
              }}
              value={option.id}
              defaultValue={defaultValue}
              defaultChecked={defaultValue === option.id}
              onClick={(e) => handleChecked && handleChecked(e)}
            />
            <span>{option.label} {option.buttonClick && <button onClick={option.buttonClick}>{option.titleButtonClick}</button>}</span>
          </Option>
        ))}
      </ContainerOptions>
    </Root>
  );
};

export default Checkbox;
